export default {
  "meeting": {
    applyrecurring: 'Le modifiche verranno applicate alla nuova pianificazione ricorrente. Le riunioni passate rimarranno invariate.',
    recurrenceDescribeTwo: 'Si ripete ogni {loopPulse} settimane il {week}, dal {start} al {end}',
    wanttodeletethemeetingfollowTwo: 'Eliminare la riunione selezionata e tutte le riunioni ricorrenti successive?',

    loopCycleSelectTips: 'Seleziona il giorno della settimana in cui ripetere.',

    export: 'Esporta',
    exportMeetingFileFuncTipsTitle: 'Conferma esportazione',
    exportMeetingFileFuncTipsContentOne: 'Non sono stati applicati filtri. Il sistema esporterà per impostazione predefinita i dati delle riunioni dell’anno corrente.',
    exportMeetingFileFuncTipsContentTwo: 'Per esportare riunioni di un periodo diverso, applica i filtri desiderati prima dell’esportazione.',

    myMeetingSearch: 'Le mie riunioni',
    meetingTimeSearch: 'Orario della riunione',
    meetingRoomsSearch: 'Sala riunioni',

    Recurring: 'Ricorrente:',
    wanttodeletethemeetingfollow: 'Sei sicuro di voler eliminare questa riunione e tutte le riunioni successive?',
    endTimeCannotBeforeBeginTime: 'La data di fine non può essere precedente alla data di inizio',
    Thismeeting: 'Questa riunione',
    Recurringmeeting: 'Riunione ricorrente',
    Checkin: 'Check-in:',
    checkinTip: 'Dopo l’abilitazione, i partecipanti possono effettuare il check-in scansionando il codice QR del pianificatore delle sale.',
    Recurrence_Setrecurrence: 'Imposta ricorrenza',
    Recurrence_Start: 'Inizio',
    Recurrence_RepeatEvery: 'Ripeti ogni',
    Recurrence_Week: 'Settimana',
    Recurrence_end: 'Fine',
    recurrenceDescribe: 'Si verifica ogni {week} a partire da {start} fino a {end}',
    Recurrence_DoesnotRepeat: 'Non ripetere',
    Recurrence_Weekly: 'Settimanale',

    AddressBookUser: 'Utente',
    AddressBookPhonebook: 'Rubrica',

    RoomByPeopleNum1: '2 persone o meno',
    RoomByPeopleNum2: '3-6 persone',
    RoomByPeopleNum3: '7-10 persone',
    RoomByPeopleNum4: '11-15 persone',
    RoomByPeopleNum5: '16-20 persone',
    RoomByPeopleNum6: '21-30 persone',
    RoomByPeopleNum7: 'Più di 30 persone',

    whoAreBound: 'Gli utenti collegati a un account di sistema vedranno la riunione nel calendario di sistema. Gli utenti che hanno fornito un’e-mail riceveranno notifiche via e-mail. Per ricevere notifiche, completa le informazioni in [Il mio profilo].',

    AttendessMeeting: 'Partecipanti:',
    SelectAttendessMeetingTip: 'Seleziona partecipanti',

    MeetingFilter: 'Filtro riunioni',
    HostedbyMe: 'Organizzato da me',
    Invitedby: 'Invitato da me',
    Otherby: 'Altri',

    "AddressIsDuplicated": "L'e-mail del contatto è duplicata",
    "meetingExpired": "Scaduto",
    titlePhoneFormat: 'Il telefono può contenere solo numeri, () + e -.',
    "selectField": "Seleziona un file",
    "Limit255": "Il nome del file non può superare i 255 caratteri",
    "nameLimit25": "Il nome non può superare i 25 caratteri",
    "emailLimit50": "L'email non può superare i 50 caratteri",
    "emailFormatError": "Inserisci un indirizzo email valido",
    "phoneLimit11": "Il numero di telefono può contenere fino a 11 cifre",
    "ParticipantsEmail": "Email del partecipante:",
    "listIsEmpty": "L'elenco è vuoto",
    "Startimporting": "Avvia caricamento",
    "Selectfile": "Seleziona file",
    "Importfile": "Importa file",
    "ImportfileTip": "*Sono supportati solo file CSV in formato Outlook (.csv) o file vCard (.vcf) per l’importazione.",
    "addParticipants": "Aggiungi partecipante",
    "multiselectdeselect": "Suggerimento eliminazione etichetta",
    "multiselectselected": "Suggerimento selezione",
    "enterOrSelectALabel": "Seleziona l'email del partecipante",
    "deleTitleContact": "Sei sicuro di voler eliminare questo contatto?",
    "delTitleContactContent": "Eliminare contatto?",
    "deleteContactTitle": "Seleziona il contatto da eliminare",
    "editcontact": "Modifica contatto",
    "Name": "Nome",
    "email": "Email",
    "telephoneNumber": "Telefono",
    "Addcontact": "Aggiungi contatto",
    "Importcontactfile": "Importa contatti",
    "AddressBook": "Rubrica",
    "Participants": "Partecipanti:",

    bindTipContent:"Questa organizzazione ha già collegato un calendario di terze parti. Pianifica le riunioni tramite Outlook/Teams.",
    Productupdatenews: 'È stato rilasciato un nuovo aggiornamento della versione.',
    bookingPerson: 'Prenotato da',
    "DeleteMeeting": "Elimina riunione",
    "wanttodeletethemeeting": "Vuoi eliminare la riunione?",
    "hasbeendeleted": "La riunione è stata eliminata",
    "theMeetingWasAborted": "Termina riunione in anticipo",
    "theMeetingWasAbortedContent": "Vuoi terminare la riunione in anticipo?",
    "determineTheAbortTask": "Termina riunione in anticipo",
    "theMeetingEndedEarly": "La riunione è terminata in anticipo.",
    "with": "con",
    "Other": "Altro",
    "tasks": "compiti",
    "conflict": "conflitto",
    "meetConflicts": "Il seguente orario della riunione è in conflitto:",
    "itIsNotAllowedToSelectThePastTime": "Non è possibile selezionare orari passati",
    "selected": "Selezionato",
    "noOverFive": "Seleziona al massimo 5 sale riunioni",
    "approvalOpinions": "Opinioni di approvazione",
    "beyondTheTimeLimitItCannotBeSelected": "Oltre il limite di tempo, non può essere selezionato",
    "startMonth": "Mese di inizio",
    "to": "a",
    "stopMonth": "Mese di fine",
    "didnTStart": "Non iniziato",
    "ONGOING": "In corso",
    "ENDED": "Finito",
    "hasBeen": "è stato",
    "booking": "prenotazione",
    "Approval": "Approvazione",
    "MeetingRoom": "Sala riunioni",
    "AllRoom": "Tutte le sale",
    "Available": "Disponibile",
    "Initiate": "Avvia riunione",
    "MeetingApproval": "Approvazione riunione",
    "PreviousMonth": "Mese precedente",
    "Today": "Oggi",
    "NextMonth": "Mese successivo",
    "YearMonth": "Anno/Mese",
    "TimeDisplay": "Visualizzazione orario",
    "MeetingTitleAbbreviation": "Abbreviazione titolo riunione",
    "InitiateMeeting": "Avvia riunione",
    "PendingMeetings": "Prossime riunioni",
    "AllMeetings": "Tutte le riunioni",
    "noMeetings": "Non ci sono riunioni a cui partecipare al momento",
    "NotStarted": "Non iniziato",
    "Organizer": "Organizzatore",
    "MeetingDateTime": "Data e ora",
    "MeetingLocation": "Posizione",
    "MeetingSubject": "Oggetto riunione",
    "Invited": "Invitati",
    "PeopleAccepted": "Persone accettate",
    "EditMeeting": "Modifica riunione",
    "CancelMeeting": "Annulla riunione",
    "InitiateEditMeeting": "Avvia/Modifica riunione",
    "Subject": "Oggetto",
    "Presenter": "Relatore:",
    "DateTime": "Data e ora",
    "TimeAndZone": "Fuso orario",
    "Attendees": "Partecipanti",
    "Addrequiredattendees": "Aggiungi partecipanti richiesti",
    "SelectRooms": "Seleziona sale",
    "Reminder": "Promemoria",
    "Remindbeforestart": "Ricorda prima dell'inizio",
    "Confirm": "Conferma",
    "topic": "Oggetto:",
    "topicplace": "Nuovo titolo riunione:",
    "speaker": "Relatore:",
    "speakerplace": "Inserisci le informazioni del relatore",
    "DateAndTime": "Data e ora:",
    "TimeZone": "Fuso orario",
    "EndDate": "Data di fine",
    "Rooms": "Sale:",
    "Notes": "Note:",
    "MeetingRoomApproval": "Approvazione sala riunioni",
    "PendingApproval": "In attesa di approvazione",
    "Approved": "Approvato",
    "nopendingapprovals": "Non ci sono approvazioni in sospeso",
    "Applicant": "Richiedente",
    "UsageTime": "Tempo di utilizzo",
    "ApprovalResult": "Risultato approvazione",
    "ApprovalComments": "Commenti sull'approvazione",
    "Approve": "Approva",
    "Reject": "Rifiuta",
    "Search": "Cerca",
    "Filter": "Filtra",
    "scanTheQRCodeToSignIn": "Scansiona il codice QR per registrarti"
  },
  "NPS": {
    "Relay": "Relay",
    "RelaySettings": "Impostazioni relay",
    "DevicePower": "Controllo alimentazione dispositivo",
    "DeviceElevation": "Controllo elevazione",
    "LinageWithNPSPower": "Collegamento con alimentazione NPS",
    "PresentationSwitch": "Interruttore di presentazione",
    "Duplicate": "Duplicato",
    "LinkagewithNPSPowe": "Collegamento con alimentazione NPS",
    "npsTooltip": "I dispositivi USB possono essere chiamati solo dal PC host che è impostato su HDMI OUT 1.",
    "nmpTooltip": "Fai clic sul pulsante 'Duplicato' per specchiare il contenuto dello schermo su altri display, sincronizzando la visualizzazione su più schermi."
  },
  "textTemplate": {
    "template2513": "Trasmissione di emergenza incendio",
    "template2514": "Si prega di evacuare dall'uscita di emergenza e dall'uscita antincendio verso un luogo sicuro secondo il piano di evacuazione.",
    "moreTemplate": "Limite del modello raggiunto",
    "add": "Aggiungi",
    "SetTemplate": "Imposta modello",
    "Emergency": "Emergenza",
    "General": "Generale",
    "BroadcastDevices": "Dispositivo di trasmissione:",
    "selectBroadcastDevices": "Seleziona dispositivi di trasmissione",
    "All": "Tutti",
    "AddTemplate": "Aggiungi modello",
    "EditTemplate": "Modifica modello",
    "deleteTemplage": "Sei sicuro di voler eliminare il modello selezionato?",
    "title": "Elimina modello",
    "selectTemplage": "Seleziona un modello!",
    "DeleteCancelled": "Eliminazione annullata!",
    "DeletedSuccessfully": "Eliminato con successo!",
    "noData": "Nessun modello disponibile, clicca nell'angolo in alto a destra per aggiungere un modello.",
    "TemplateTitle": "Titolo modello:",
    "BroadcastType": "Tipo di trasmissione:",
    "BroadcastTypeDialog": "Tipo di trasmissione:",
    "selectBroadcastType": "Seleziona tipo di trasmissione",
    "BroadcastDuration": "Durata trasmissione:",
    "BroadcastDevice": "Dispositivo di trasmissione:",
    "BroadcastContent": "Contenuto trasmissione:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "Errore!",
    "mediaTimeStateNotifyErrorContent": "Il servizio di streaming è scaduto, per favore contatta il tuo agente per rinnovare in tempo.",
    "mediaTimeStateNotifyWarnTitle": "Attenzione!",
    "mediaTimeStateNotifyWarnContent": "Attualmente sei nello stato di prova che consente solo di inviare trasmissioni e streaming live a un massimo di 3 dispositivi terminali.",
    "mediaTimeStateNotifySuccessTitle": "Rinnovo riuscito",
    "mediaTimeStateNotifySuccessContent": "Il tuo servizio di streaming è pronto per l'uso normale. Grazie.",
    "company": "Nome azienda:",
    "tableAddress": "Indirizzo:",
    "createTime": "Data di creazione:",
    "email": "Email:",
    "phone": "Telefono:",
    "Trial": "Prova",
    "TrialWorkstation": "Attualmente sei nello stato di prova che consente solo di inviare trasmissioni e streaming live a un massimo di 3 dispositivi terminali.",
    "Normal": "Normale",
    "NormalWorkstation": "Il periodo di validità del tuo servizio di streaming va dal",
    "to": "al",
    "Advent": "Avviso",
    "AdventWorkstationOne": "Il tuo servizio di streaming scadrà il",
    "AdventWorkstationTwo": ", per favore contatta il tuo agente per rinnovare in tempo per l'uso normale.",
    "Expired": "Scaduto",
    "ExpiredWorkstation": "Il tuo servizio di streaming è scaduto, per favore contatta il tuo agente per rinnovare in tempo."
  },
  "route": {
    "dashboard": "Dashboard",
    "i18n": "I18n (Internazionalizzazione)",
    "Devices": "Dispositivi",
    "Broadcast": "Trasmissione",
    "Schedule": "Programma",
    "Resources": "Risorse",
    "Live": "Streaming",
    "meetings": "Riunione"
  },
  "navbar": {
    "updates":"Últimas atualizações",
    "logOut": "Esci",
    "screenfull": "Schermo intero",
    "oprofile": "Il mio profilo",
    "settings": "Impostazioni",
    "language": "Lingua",
    "BackTianwa": "Torna a Tianwa",
    "newUserGuide": "Guida per nuovi utenti"
  },
  "feedback": {
    "Feedback": "Feedback",
    "email": "Per favore, lascia la tua email per il nostro feedback.",
    "content": "Benvenuto e lascia un messaggio per migliorare i nostri prodotti. Grazie per i tuoi commenti.",
    "submit": "Invia",
    "emailNoEmpty": "L'email non può essere vuota",
    "emailTrueRule": "Per favore, inserisci il formato email corretto",
    "contentNoEmpty": "Il contenuto non può essere vuoto",
    "feedbackSuccess": "Feedback riuscito",
    "feedbackFailed": "Feedback fallito",
    "emailNoChinese": "La casella di posta non può contenere caratteri cinesi",
    "emailLength": "Tra 5 e 50 caratteri",
    "emailSpecialString": "La casella di posta non può contenere stringhe speciali"
  },
  "login": {
    checkPasswordTitleTwo: 'Imposta una password di almeno 6 caratteri, includendo lettere e numeri. I caratteri speciali sono consentiti (senza restrizioni).',
    captcha: 'Codice di verifica',
    checkPasswordTitle: 'La password deve contenere almeno 6 caratteri e non può essere composta solo da numeri',
    "title": "BENVENUTO",
    "logIn": "Accedi",
    "consoleLogin": "Accesso alla console",
    "username": "Nome utente",
    "password": "Password",
    "any": "qualsiasi",
    "thirdparty": "Oppure connettiti con",
    "thirdpartyTips": "Non può essere simulato in locale, quindi per favore combina la tua simulazione aziendale!!!",
    "placeholder": "[\n  \"Nome utente\",\n  \"Password\",\n  \"Codice di verifica\"\n]",
    "userNameTitle": "Nome utente errato!",
    "forget": "Dimenticato?",
    "loginTitle0": "Accesso riuscito!",
    "loginTitle1000": "Nome utente o password errati!",
    "loginTitle1001": "Nome utente e password devono essere compilati!",
    "loginTitle1002": "Il codice di verifica deve essere compilato!",
    "loginTitle1003": "Lo stato dell'utente è illegale, accesso fallito!",
    "loginTitle1004": "Errore nel codice di verifica!",
    "loginTitle1005": "Non loggato, per favore accedi prima!",
    "loginTitle1006": "Le due password sono diverse!",
    "loginTitleUserName": "Il nome utente deve essere compilato!",
    "loginTitlePwd": "La password deve essere compilata!",
    "loginTitleVercode": "Il codice di verifica deve essere compilato!",
    "titleLoginNameFormat": "L'account deve essere composto da caratteri, o da caratteri e numeri.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Dispositivi",
    "btnRoadcast": "Trasmissione",
    "btnResources": "Risorse",
    "btnLive": "Streaming",
    "meetings": "Riunione",
    "todaySchedule": "Programma di oggi",
    "allSkedules": "Tutti i programmi",
    "details": "Dettagli",
    "btnStart": "Inizia",
    "titleContent": "Ciao! La Console Q-NEX è a tua disposizione. Iniziamo!",
    "btnExit": "Esci"
  },
  "devices": {
    ptzCamera:'Telecamera PTZ',
    "start": "INIZIA",
    "stop": "FERMA",
    "nmpPowerOff_mandatory": "In trasmissione (non obbligatoria)",
    "nmpPowerOff_nomandatory": "In trasmissione (non obbligatoria). Continuare l'esecuzione?",
    "nmpsPowerOff_mandatory": "Alcuni NMP sono in trasmissione (obbligatoria).",
    "nmpsPowerOff_nomandatory": "Alcuni NMP sono in trasmissione (non obbligatoria). Continuare l'esecuzione?",
    "reset": "Ripristina",
    "displayedInTheControlArea": "Visualizzato nel centro di controllo",
    "dragOrder": "Ordine di trascinamento",
    "areaSettingTwoNotice": "*Il controllo RS232, AC e remoto sono visualizzati nel centro di controllo a seconda dello stato di associazione NMP nel dashboard.",
    "areaSettingThreeNotice": "*Il controllo CBX è visualizzato nel centro di controllo a seconda dello stato di associazione NMP nel dashboard.",
    "controlSet": "Impostazioni del centro di controllo",
    "vcbNoLine": "Nessun dispositivo CBX online",
    "vcbNoBound": "Nessun dispositivo CBX associato",
    "tscNoBound": "RS232 su TSC non è associato a nessun dato. Si prega di notificare all'amministratore di associarlo nel dashboard.",
    "light": "Controllo alimentazione",
    "vcbpower": "Alimentazione",
    "rs232Control": "Controllo seriale",

    "CBX": {
    "powerSupplyON": "Accensione",
    "powerSupplyOFF": "Spegnimento",
    "lockScreenON": "Blocco attivato",
    "lockScreenOFF": "Blocco disattivato",
    "childLockON": "Blocco bambini attivato",
    "childLockOFF": "Blocco bambini disattivato",
    "energySavingON": "Risparmio energetico attivato",
    "energySavingOFF": "Risparmio energetico disattivato",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "Altoparlante",
    "brightAdjustment": "Luminosità",
    "other": "Altre funzionalità..."
  },

    "InterfaceOne": "Interfaccia Uno",
    "InterfaceTwo": "Interfaccia Due",
    "abcStyleP": "Spiacenti! TSC e (NMP, MBX, NPS, NDP100, NDP500) non possono essere selezionati contemporaneamente",
    "masterControl": "principale",
    "powerSupply": "Alimentazione",
    "RecordingControl": "Controllo registrazione",
    "RecordingControlSystem": "Sistema di acquisizione lezioni",
    "LiquidCrystal": "Display LCD interattivo",
    "projector": "Proiettore",
    "othertype": "Altro",
    "lockScreen": "Blocca",
    "childLock": "Blocco bambini",
    "energySaving": "Risparmio energetico",
    "signalSourceSwitching": "Sorgente di ingresso",
    "volumeAdjustment": "Altoparlante",
    "brightAdjustment": "Luminosità",
    "other": "Altre funzionalità",
    "otherFunction": "Funzione",
    "send": "Invia",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "Condizionatore d'aria",
    "titleDevices": "Filtro gruppi:",
    "content": "Cerca",
    "selectALL": "Seleziona TUTTO",
    "SelectRecentPage": "Seleziona pagina corrente",
    "controlPanel": "Centro di controllo",
    "displayInputSwitch": "Interruttore di ingresso display",
    "chooseINPUTSources": "Scegli le sorgenti di ingresso",
    "speakerVolume": "Volume audio",
    "bass": "Bassi",
    "treble": "Alti",
    "MICVolume": "Volume MIC",
    "AirConditioning": "Condizionatore d'aria",
    "model": "Modello",
    "setTemp": "Imposta temperatura",
    "fanSpeed": "Velocità ventola",
    "bold": "Oscillazione",
    "projectionScreen": "Schermo di proiezione",
    "electronicLock": "Serratura elettrica",
    "electronicLock1": "Serratura elettrica",
    "selectDevices": "Per favore, seleziona un dispositivo o un gruppo di dispositivi",
    "isCompelType": "Controllo dispositivo non disponibile a causa della trasmissione obbligatoria, riprova più tardi.",
    "mainPower": "Alimentazione principale",
    "extraPower": "Alimentazione extra",
    "power": "Alimentazione",
    "hdmiBroadcast": "Trasmissione",
    "equipmentState1": "Accensione",
    "equipmentState2": "Spegnimento",
    "equipmentState3": "Offline",
    "main": "Principale",
    "external": "Esterno",
    "ProjectionScreen": "Schermo di proiezione",
    "UP": "SU",
    "DOWN": "GIÙ",
    "LOCK": "BLOCCA",
    "UNLOCK": "SBLOCCA",
    "PleaseDevice": "Per favore, seleziona il/i dispositivo/i a sinistra",
    "RemoteControl": "Telecomando",
    "Action": "Azione",
    "Devicefilter": "Filtro dispositivi",
    "DeviceStatus": "Stato",
    "DeviceType": "Tipo",
    "currentAudioSource": "Sorgente audio corrente",
    "audioSwitching": "Commutatore di uscita audio"
  },
  "broadcast": {
    "isBoarding": "(In trasmissione)",
    "last3Days": "ULTIMI 3 GIORNI",
    "last7Days": "ULTIMI 7 GIORNI",
    "last30Days": "ULTIMI 30 GIORNI",
    "historyRecord": "Cronologia",
    "SelectDestination": "1. Seleziona destinazione",
    "BroadcastingConsole": "2. Console di trasmissione",
    "Notification": "Notifica",
    "btnStop": "Stop",
    "btnStart": "Avvia",
    "Letters60": "(meno di 60 lettere)",
    "Letters300": "(meno di 300 lettere)",
    "LastingTime": "Durata:",
    "Title": "Titolo:",
    "Content": "Contenuto:",
    "Cannotquit": "Trasmissione obbligatoria",
    "ChooseMedia": "Seleziona un file multimediale",
    "Broadcasting": "Trasmissione",
    "dialogTitle": "Risorse video e audio",
    "SortBy": "Ordina per",
    "btnBake": "Torna indietro",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "coxAll": "Tutti",
    "PublicCloud": "Memoria pubblica",
    "IndividualCloud": "Memoria personale",
    "selFile": "Seleziona un file o un gruppo.",
    "StopBroadcast": "Ferma trasmissione",
    "StartBroadcasting": "Avvia trasmissione",
    "StopBroadcasting": "Ferma trasmissione",
    "ForceQuit": "Uscita forzata",
    "PleaseMediaFile": "Per favore, seleziona un file multimediale",
    "PleaseDevice": "Per favore, seleziona un dispositivo",
    "broadcast_0": "Avvia trasmissione",
    "broadcast_2500": "Superato il numero massimo di dispositivi collegabili per il server multimediale",
    "broadcast_2501": "Errore nel file di trasmissione",
    "broadcast_2502": "Trasmissione terminata",
    "broadcast_2503": "Impossibile ottenere informazioni dal server multimediale",
    "broadcast_2510": "Attenzione! Attualmente sei nello stato di prova, fino a 3 dispositivi terminali possono ricevere comandi di trasmissione, per favore controlla il numero di dispositivi selezionati.",
    "broadcast_2018": "Servizio di streaming interrotto",
    "broadcast_2019": "Il servizio di streaming è scaduto",
    "broadcast_2512": "Superato il limite di quantità di modelli.",
    "broadcast_2513": "Trasmissione di emergenza incendio",
    "broadcast_2514": "Si prega di evacuare dall'uscita di emergenza e dall'uscita antincendio verso un luogo sicuro secondo il piano di evacuazione.",
    "broadcast_2006": "Dispositivo non trovato",
    "broadcast_2": "Il servizio disco è anomalo",
    "broadcast_2515": "Seleziona un dispositivo che non ha capacità di trasmissione",
    "broadcast_2516": "Seleziona file che superano la risoluzione massima supportata da NMP",
    "broadcast_2517": "Seleziona file che superano la risoluzione massima supportata da NDP500",
    "broadcast_Title": "Avviso di trasmissione.",
    "broadcast_TitleNDP500": "Avviso di trasmissione NDP500",
    "broadcast_content": "Il dispositivo supporta fino a 4K@30FPS, con risoluzione ottimale 1080P@30FPS.",
    "broadcast_contentNDP500": "NDP500/600 supporta fino a 1080P@30FPS, con risoluzione ottimale 720P@30FPS.",
    "broadcast_noSupported": "I seguenti video selezionati non sono supportati per la trasmissione:",
    "broadcast_noSupportedNDP500": "I seguenti video selezionati non sono supportati per la trasmissione su NDP500/600:"
  },
  "resources": {
    "uploadNameLengthError": "Il nome del file caricato non può superare le 100 parole!",
    "onUploadFile": "Nessun file da caricare",
    "open": "Apri",
    "fold": "Piega",
    "close": "Chiudi",
    "PublicCloud": "Memoria pubblica",
    "IndividualCloud": "Memoria personale",
    "TransfersHistory": "Cronologia trasferimenti",
    "btnDownload": "Scarica",
    "btnDelete": "Elimina",
    "btnUploadFile": "Carica file",
    "btnNewFolder": "Nuova cartella",
    "btnBake": "Torna indietro",
    "coxAll": "Tutti",
    "uploadError": "La dimensione del file caricato non può superare 1G!",
    "MD5": "Verifica MD5",
    "merge": "Unione",
    "transcoding": "Transcodifica",
    "uploadFailed": "Caricamento fallito",
    "fileError": "Errore di lettura del file, verifica il file.",
    "tableName": "Nome",
    "tableSize": "Dimensione",
    "tableType": "Tipo",
    "tableTimeAdded": "Orario di aggiunta",
    "tableAction": "Azione",
    "btnRename": "Rinomina",
    "btnMoveTo": "Sposta in...",
    "ClearAll": "Pulisci tutto",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "addSuccess": "Aggiunto con successo!",
    "addError": "Impossibile aggiungere!",
    "editSuccess": "Modificato con successo!",
    "editError": "Impossibile modificare!",
    "delSuccess": "Eliminato con successo!",
    "delError": "Impossibile eliminare!",
    "diskError3000": "Spazio totale superato, operazione fallita!",
    "diskError3001": "Spazio pubblico superato, operazione fallita!",
    "diskError3002": "Spazio personale superato, operazione fallita!",
    "diskError3003": "Impossibile trovare i dati, verifica se il server multimediale è associato!",
    "diskError3004": "Il nome della cartella esiste già!",
    "diskError3005": "Impossibile ottenere la cartella!",
    "diskError3006": "Non puoi creare più di 99 cartelle nello stesso livello!",
    "diskError3007": "Esiste già un file con lo stesso nome, la modifica è fallita!",
    "diskError3008": "Esiste già una cartella con lo stesso nome, la modifica è fallita!",
    "diskError3009": "Il file supera lo spazio rimanente e il caricamento è fallito!",
    "diskError3010": "Caricamento fallito!",
    "diskError3011": "Verifica del file fallita, riprova a caricare il file!",
    "diskError3012": "Impossibile ottenere l'indirizzo della cloud privata, operazione fallita!",
    "diskError3013": "Le combinazioni di file non possono superare i 100M, i file di grandi dimensioni devono essere scaricati separatamente!",
    "diskError3014": "Compressione fallita, per favore seleziona nuovamente il file da scaricare!",
    "diskError3015": "Hai bisogno di permessi per eseguire questa azione",
    "downloadError": "Download fallito!",
    "mobileError": "Spostamento fallito!",
    "root": "Tutti i file",
    "Name": "Nome",
    "Size": "Dimensione",
    "Type": "Tipo",
    "uploadFile": "Carica file",
    "newFolder": "Nuova cartella",
    "tableTime": "Orario",
    "permission": "Permessi insufficienti!",
    "notifyTitle": "Notifica",
    "notifyContent": "L'utente non ha i permessi sufficienti per accedere!",
    "sortFileName": "Nome del file",
    "sortTime": "Orario",
    "sortSize": "Dimensione",
    "sortType": "Tipo",
    "moveTo": "Sposta in",
    "test": "Nuovo",
    "delTitle": "Eliminare?",
    "delTitleContent": "Il contenuto selezionato verrà eliminato dal database. L'operazione non può essere annullata. Sei sicuro di voler continuare?",
    "delCancelButton": "Annulla",
    "delConfirmButton": "Conferma"
  },
  "userMge": {
    "userName": "Nome utente:",
    "jobNumber": "ID dipendente:",
    "email": "Email:",
    "phone": "Telefono:",
    "group": "Gruppo:",
    "oldPassword": "Vecchia password:",
    "newPassword": "Nuova password:",
    "confirmNewPassword": "Conferma nuova password:",
    "btnSave": "Salva modifiche",
    "titleChangePassword": "Cambia password",
    "titleMyProfile": "Il mio profilo",
    "name": "Nickname:",
    "error1400": "L'account (personalizzato) esiste già, operazione fallita!",
    "error1401": "L'account (generato dal sistema) esiste già, operazione fallita!",
    "error1402": "Il gruppo non esiste, importazione fallita!",
    "error1403": "Errore nei dati",
    "error1404": "Permessi insufficienti",
    "selUser": "Per favore seleziona un utente!",
    "error1405": "Impossibile ottenere il ruolo",
    "error1406": "Il formato dei dati dell'utente importato è errato",
    "error1407": "L'email esiste già e l'operazione è fallita.",
    "error1408": "Il telefono esiste già e l'operazione è fallita.",
    "editSuccess": "Salvato con successo!",
    "ChangePassword": "Cambia password",
    "UserPrivacyAgreement": "Politica sulla privacy dell'utente"
  },
  "information": {
    "_2602": "Dispositivo offline",
    "_2603": "Trasmissione fallita",
    "_2604": "La trasmissione è stata interrotta",
    "_2605": "Lo spazio di archiviazione è pieno",
    "_2606": "minuti fa",
    "_2607": "ore fa",
    "_2609": "fallito, per favore",
    "_2609_a": "clicca qui",
    "_2609_time": "per gestirlo in tempo",
    "userType": "Amministratore",
    "unreadNoticeFirst": "Notifica non letta prima",
    "sortByTime": "Ordina per tempo",
    "coxRead_1": "Letto",
    "coxRead_0": "Non letto",
    "allCoxRead": "Segna tutto come letto",
    "load": "Caricamento...",
    "noData": "Nessun altro dato",
    "viewALLMessages": "Visualizza TUTTI i messaggi"
  },
  "input": {
    "select": "Per favore seleziona",
    "thisField": "Questo campo deve essere compilato.",
    "titleShooleNub60": "meno di 60 lettere",
    "titleShooleNub300": "meno di 300 lettere",
    "Offline": "Offline"
  },
  "schedule": {
    "OnlyManual": "Solo Manuale",
    "runStartNow": "Esegui compito",
    "runStopNow": "Ferma compito",
    "tackExecutionStart": "Compito in esecuzione",
    "tackExecutionStop": "Esecuzione compito fermata",
    "dehumidification": "Deumidificazione",
    "airSupply": "Alimentazione dell'aria",
    "masterControl": "principale:",
    "powerSupply": "Alimentazione",
    "lockScreen": "Blocco",
    "RecordingControl": "Controllo registrazione",
    "RecordingControlSystem": "Sistema di acquisizione lezioni",
    "LiquidCrystal": "Display LCD interattivo",
    "projector": "Proiettore",
    "othertype": "Altro",
    "childLock": "Blocco bambini",
    "energySaving": "Risparmio energetico",
    "signalSourceSwitching": "Fonte di ingresso",
    "other": "Altre funzioni:",
    "otherFunction": "Funzione",
    "send": "Invia",
    "ON": "ACCESO",
    "OFF": "SPENTO",
    "btnAddSchedule": "Ripristina",
    "EditSchedulelist": "Modifica pianificatore",
    "AddSchedulelist": "Aggiungi pianificatore",
    "RestoreSchedulelist": "Ripristina",
    "btn": "Annulla",
    "btnNewList": "Nuovo pianificatore",
    "ListName": "Nome",
    "Cannotquit": "Obbligatorio",
    "NOCannotquit": "NO",
    "ListValidityPeriod": "Periodo di validità",
    "ListDescription": "Descrizione",
    "currentSchedule": "Elenco pianificatori",
    "historySchedule": "Elenco storico",
    "selectTime": "Tempo",
    "selectTimeTable": "Tempo",
    "taskType": "Tipo di compito",
    "selectBroadcasting": "Trasmissione",
    "selectDeviveControl": "Controllo dispositivo",
    "newSchedule": "Nuovo compito",
    "newChecklist": "Nuova checklist",
    "titleStatus": "Stato",
    "titleType": "Tipo",
    "titleStartTime": "Ora di inizio",
    "titleEndTime": "Ora di fine",
    "titleRepeat": "Ripeti",
    "titleName": "Nome",
    "titleAction": "Azione",
    "tableEnabled": "Abilitato",
    "tablePaused": "Pausa",
    "tableEdit": "Modifica",
    "tableDelete": "Elimina",
    "tableVolumeEdit": "Volume trasmissione",
    "tableBroadcastTitle": "Titolo",
    "tableBroadcastContent": "Contenuto",
    "tableBroadcastList": "Elenco",
    "tableBroadcast": "Compulsivo",
    "btnRemoveCompletely": "Rimuovi completamente",
    "btnEnabled": "Compito abilitato",
    "btnPaused": "Disabilita compito",
    "btnDelete": "Elimina",
    "repeat0": "LUN",
    "repeat1": "MAR",
    "repeat2": "MER",
    "repeat3": "GIO",
    "repeat4": "VEN",
    "repeat5": "SAB",
    "repeat6": "DOM",
    "dialogTitleAdd": "Nuovo compito di controllo dispositivo",
    "dialogTitleEdit": "Modifica compito di controllo dispositivo",
    "newBroadcastingSchedule": "Nuovo compito di trasmissione",
    "editBroadcastingSchedule": "Modifica compito di trasmissione",
    "chooseDevice": "Scegli dispositivo",
    "timeSetting": "Impostazione tempo",
    "controlBroadcasting": "Opzione di trasmissione",
    "controlOption": "Opzione di controllo",
    "scheduleName": "Nome compito:",
    "destination": "Destinazione",
    "timeTilte": "Tempo",
    "repeatTitle": "Ripeti",
    "dialogRepeat0": "LUN",
    "dialogRepeat1": "MAR",
    "dialogRepeat2": "MER",
    "dialogRepeat3": "GIO",
    "dialogRepeat4": "VEN",
    "dialogRepeat5": "SAB",
    "dialogRepeat6": "DOM",
    "dialogOnceType": "Una volta",
    "dialogRepeatType": "Ripeti",
    "Manual": "Manuale",
    "ManualContent": "Puoi eseguire manualmente questi compiti una volta terminata la configurazione.",
    "mainPower": "Alimentazione principale",
    "powerControl": "Controllo alimentazione",
    "tableDisplayInputSwitch": "Commutazione ingresso display",
    "tableAirConditioning": "Condizionatore d'aria",
    "tableProjectionScreen": "Schermo di proiezione",
    "tableElectronicLock": "Serratura elettrica",
    "interactiveFlatPanel": "Pannello piatto interattivo",
    "displayInputSwitch": "Commutazione ingresso display",
    "speakerVolume": "Volume audio",
    "MICVolume": "Volume MIC",
    "ProjectionScreen": "Schermo di proiezione",
    "ElectronicLock": "Serratura elettrica",
    "AirConditioning": "Condizionatore d'aria",
    "AirConditioningPower": "Alimentazione",
    "AirConditioningModel": "Modello",
    "AirConditioningTEMP": "Temperatura",
    "AirConditioningFanSpeed": "Velocità ventilatore",
    "OPEN": "APRI",
    "CLOSE": "CHIUDI",
    "UP": "SU",
    "DOWN": "GIÙ",
    "PowerOFF": "SPENTO",
    "PowerON": "ACCESO",
    "ModelAuto": "Automatico",
    "ModelCool": "Raffreddare",
    "ModelHeat": "Riscaldare",
    "ModelAir": "Lato aria",
    "TEMPLow": "Basso",
    "TEMPMiddle": "Medio",
    "TEMPHigh": "Alto",
    "btnSave": "Salva",
    "btnNext": "SUCCESSIVO",
    "StartTime": "Ora di inizio",
    "StopTime": "Ora di fine",
    "Mandatory": "Obbligatorio",
    "Video": "Video&Audio",
    "Notification": "Notifica",
    "btnFile": "Seleziona un file multimediale",
    "LastingTime": "Durata",
    "textTitle": "Titolo",
    "textContent": "Contenuto",
    "textTitleLetters": "Meno di 60 lettere",
    "textContentLetters": "Meno di 320 lettere",
    "CannotquitYES": "SÌ",
    "CannotquitNo": "No",
    "YES": "SÌ",
    "No": "No",
    "delTitleContent": "Sei sicuro di voler eliminare questo pianificatore?",
    "delTitleListContent": "Il pianificatore eliminato verrà spostato nell'elenco storico e potrà essere ripristinato",
    "deleListTitle": "Eliminare pianificatore?",
    "delTitleListContent1": "Eliminare il pianificatore causerà la cancellazione dei compiti associati, confermare per favore.",
    "deleListTitle1": "Sei sicuro di voler eliminare questo pianificatore?",
    "delTitle": "Elimina?",
    "btnConfirm": "Conferma",
    "coxAll": "TUTTI",
    "coxBroadcasting": "Trasmissione",
    "coxDeviveControl": "Controllo dispositivo",
    "rdMandatory": "SÌ",
    "noRdMandatory": "NO",
    "startDate": "Data di inizio",
    "endedDate": "Data di fine",
    "or": "-",
    "broadcastingType": "Tipo",
    "ChooseTime": "Scegli ora",
    "ChooseDate": "Scegli data",
    "newScheduleList": "Nuovo pianificatore",
    "editScheduleList": "Modifica pianificatore",
    "listName": "Nome",
    "listValidityPeriod": "Periodo di validità",
    "listDescription": "Descrizione",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "addSuccess": "Aggiungi con successo!",
    "addError": "Aggiunta fallita!",
    "editSuccess": "Modifica con successo!",
    "editError": "Modifica fallita!",
    "delSuccess": "Eliminato con successo!",
    "delError": "Eliminazione fallita!",
    "restoreSuccess": "Elenco pianificatori ripristinato con successo",
    "restoreError": "Ripristino dell'elenco pianificatori fallito",
    "restoreTitleContent": "Questo orario confligge con l'orario del pianificatore nell'elenco, selezionare di nuovo",
    "Enabled": "Abilitato",
    "Paused": "In pausa",
    "Title": "Titolo:",
    "Content": "Contenuto:",
    "errorScheduleNameRequired": "Il nome del compito deve essere compilato",
    "errorDeviceRequired": "Seleziona il dispositivo di destinazione",
    "deleTitle": "Sei sicuro di voler eliminare questo compito?",
    "loopList": "Elenco ciclo",
    "errorPleaseDateRange": "Seleziona un intervallo di date",
    "addError_2009": "Nome pianificatore duplicato",
    "conflicts": "L'orario del compito confligge con il seguente:",
    "Pleaseagain": "Inserisci di nuovo",
    "errorScheduleName": "Nome compito",
    "errorListName": "Nome pianificatore",
    "today": "Oggi",
    "yesterday": "Ieri",
    "thisWeek": "Questa settimana",
    "lastWeek": "Settimana scorsa",
    "lastMonth": "Ultimo mese",
    "thisMonth": "Questo mese",
    "times": "Volte",
    "TimeConflicts": "Conflitti di orario",
    "editError_2006": "Dispositivo non trovato",
    "editError_2010": "Nome compito duplicato",
    "editError_2100": "Il compito è scaduto, impossibile avviare.",
    "ListTimeExpired": "L'orario del pianificatore è scaduto, selezionare di nuovo",
    "TimeExpired": "Tempo scaduto",
    "ControlOption": "Manca l'opzione di controllo",
    "Pleaseleastone": "Seleziona almeno un'opzione di controllo",
    "Enter": "Inserisci",
    "TitleFilled": "Il titolo deve essere compilato",
    "ContentFilled": "Il contenuto deve essere compilato",
    "PleaseMediaFile": "Seleziona un file multimediale",
    "PleaseSchedule": "Seleziona un compito",
    "delTitleScheduleContent": "Il compito eliminato non può essere recuperato.",
    "deleTitleSchedule": "Sei sicuro di voler eliminare questo compito?",
    "deleteScheduleTitle": "Seleziona il compito da eliminare",
    "PleaseFillColumn": "Compila il nome del pianificatore",
    "PleaseDate": "Seleziona la data",
    "Previous": "Precedente",
    "RemoteControl": "Controllo remoto",
    "taskhasexpired": "Questo compito è scaduto, contatta il creatore per aggiornare l'orario.",
    "execute": "Esegui",
    "broadcastingList": "Elenco trasmissioni",
    "volumeSuccess": "Volume impostato con successo",
    "volumeFailed": "Impostazione volume fallita"
  },
  "live": {
    "StreamingRoom": "Sala di streaming",
    "btnAddNewRoom": "Aggiungi nuova sala",
    "Steaming": "Streaming",
    "Creater": "host:",
    "Address": "Indirizzo RTMP:",
    "StreamingURL": "URL di streaming live:",
    "DestinationNMP": "Seleziona destinazione NMP:",
    "stop": "FERMA",
    "stat": "AVVIA",
    "btnCope": "Clicca per COPIARE",
    "QRcode": "Codice QR",
    "Refresh": "Ricarica",
    "AddNewRoomTitle": "Aggiungi nuova sala di streaming",
    "editNewRoomTitle": "Modifica sala di streaming",
    "roomName": "Nome della sala:",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "save": "Salva",
    "delTitleContent": "Sei sicuro di voler eliminare questo programma?",
    "delTitle": "Elimina?",
    "delCancelButton": "Annulla",
    "delConfirmButton": "Conferma",
    "addSuccess": "Aggiunto con successo!",
    "addError": "Aggiunta fallita!",
    "editSuccess": "Modificato con successo!",
    "editError": "Modifica fallita!",
    "delSuccess": "Eliminato con successo!",
    "delError": "Eliminazione fallita!",
    "Stopstreaming": "Ferma streaming",
    "Startstreaming": "Avvia streaming",
    "error2504": "Impossibile ottenere l'indirizzo di streaming live del server multimediale",
    "error2505": "Nome sala di streaming duplicato",
    "error2506": "Il dispositivo è stato occupato da un altro segnale di streaming",
    "error1900": "Il parametro accessibile è vuoto",
    "error2503": "Impossibile ottenere informazioni dal server multimediale",
    "error2507": "Indirizzo di streaming live duplicato",
    "copySuccess": "Il contenuto è stato copiato negli appunti.",
    "copyError": "Il browser non supporta la copia automatica",
    "flashControl": "Flash non è installato o abilitato. Si prega di riprovare dopo aver installato o abilitato Flash.",
    "liveStreaming": "Nessuna sorgente di streaming live trovata.",
    "btnflash": "Installa/Abilita",
    "serverAddress": "Indirizzo del server",
    "addressKey": "Chiave:",
    "watchingAddress": "Indirizzo di visione",
    "audioOnly": "Solo audio",
    "enterTheKey": "La chiave deve essere compilata."
  },
  "guidepages": {
    "next": "Prossimo-controllo dispositivo",
    "next1": "Prossimo-prova a controllare",
    "next2": "Prossimo-trasmissione",
    "next3": "Prossimo-avvia trasmissione",
    "next4": "Prossimo-ferma trasmissione",
    "next5": "Prossimo-trasmissione testo",
    "next6": "Prossimo-configura attività",
    "next7": "Prossimo-aggiungi nuova attività",
    "next8": "Prossimo-elenco storico",
    "next9": "Prossimo-archiviazione cloud",
    "next10": "Prossimo-streaming live",
    "next11": "Prossimo-configura streaming live",
    "exit": "Esci",
    "guideContent": "Contenuto guida",
    "btnHomepage": "Pagina iniziale",
    "btnDevices": "Dispositivi",
    "btnBroadcast": "Trasmissione",
    "btnSchedule": "Programma",
    "btnResources": "Risorse",
    "btnStreaming": "Streaming",
    "btnPrevious": "Precedente"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/it.js